// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"16":"84f7b2be20b27467","167":"acc6e97e7277e8f2","274":"7183ece15fc5809a","418":"7b1789c8ca9b6dda","480":"864e595f3460eac0","639":"1ff8e073397bbd17","640":"f7882ae2a7723e83","779":"0ad930a2eda7f659","850":"a403799b41bfe1d9","879":"597dcd1df1a15dbd","981":"dc3bd60985812500"}[chunkId] + ".js";
};